<template>
  <section class="team-circles-2 wf-section">
    <div class="container-6">
      <div v-if="$store.state.searchQuery && filteredItems.length > 0" class="search-results-header">
        <p class="search-results-info">
          Found <strong>{{ filteredItems.length }}</strong> result{{ filteredItems.length !== 1 ? 's' : '' }} for 
          <span class="search-query-badge">"{{ $store.state.searchQuery }}"</span>
        </p>
      </div>
      <div v-if="filteredItems.length > 0" class="team-grid-2">
        <div
          id="w-node-_944ed45d-0b36-0fe2-68a3-da8baa79c596-5f1c185e"
          class="team-card-2"
          v-for="item in filteredItems"
          :key="item.title"
        >
          <a :href="item.link" target="_blank" class="card-wrapper">
            <img
              :src="item.image ? item.image : 'images/1_1.jpg'"
              loading="lazy"
              alt=""
              class="team-member-image-2"
              :class="{ 'image-align-top': item.imageAlignTop }"
            />
            <div class="newdetailsdiv">
              <div class="team-member-name-2 newslink" v-html="highlightText(item.title, $store.state.searchQuery)"></div>
              <div class="team-member-position-2" v-html="highlightText(item.about, $store.state.searchQuery)"></div>
              <!-- <p class="newsdate">
                {{
                  new Date(item.date).toLocaleDateString("en-UK", {
                    year: "numeric",
                    day: "numeric",
                    month: "short",
                  })
                }}
              </p> -->
            </div>
          </a>
        </div>
        <!-- 
        <div
          id="w-node-_944ed45d-0b36-0fe2-68a3-da8baa79c596-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/1_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="#" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_16fe75e7-251c-c0e5-e339-559f6ca11bf5-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/2_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="#" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_536f325e-061c-5f12-5d4e-e147bfe5f28a-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/3_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="#" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.<strong><br /></strong>
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_13b968d9-ded0-7a65-5527-d942884a6e6a-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/1_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="#" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_96dac795-33c4-3678-36e5-ccbee9e267c1-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/2_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="#" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
        <div
          id="w-node-_1eeb25ca-594e-5845-355b-9c46558f7f91-5f1c185e"
          class="team-card-2"
        >
          <img
            src="images/3_1.jpg"
            loading="lazy"
            alt=""
            class="team-member-image-2"
          />
          <div class="newdetailsdiv">
            <div class="team-member-name-2">
              <a href="#" class="newslink"
                >Charity for needy People, make a difference in their lives</a
              >
            </div>
            <div class="team-member-position-2">
              We were established as a EverCare ond charity in 1990 and began to
              operate and some verition.<strong><br /></strong>
            </div>
            <p class="newsdate">15 May 23</p>
          </div>
        </div>
         -->
      </div>
      <div v-if="filteredItems.length === 0 && $store.state.searchQuery" class="no-results">
        <p>No documents found matching "{{ $store.state.searchQuery }}"</p>
      </div>
      <div v-else-if="filteredItems.length === 0" class="no-results">
        <p>No documents available</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Documents",
  data() {
    return {
      docs: [
      {
          title: "Dr. Fowzia Siddiqui addresses participants at UK gatherings advocating for Dr. Aafia's release",
          link: "https://cdn.cloudious.net/file-1789973060641-391527675.pdf",
          image: "https://cdn.cloudious.net/file-1789973023919-713940602.jpg",
          about: "Dr. Fowzia Siddiqui addresses participants at gatherings held in various UK cities during her visit to Britain, advocating for Dr. Aafia's release. 14 September 2026",
          imageAlignTop: true,
        },
      {
          title: "Seerat of Prophet (PBUH) Teaches Us to Honour Daughters, Redress Wrongs: Dr Fowzia",
          link: "https://cdn.cloudious.net/file-1788782699345-727409559.pdf",
          image: "https://cdn.cloudious.net/file-1788782781969-690160875.jpg",
          about: "Seerat of Prophet (PBUH) Teaches Us to Honour Daughters, Redress Wrongs: Dr Fowzia. 03 September 2026",
          imageAlignTop: true,
        },
      {
          title: "Azaadi Mushaira Held Under Aafia Movement to Highlight the Value of Freedom as a Blessing",
          link: "https://cdn.cloudious.net/file-1788436718740-479459519.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Azaadi Mushaira Held Under Aafia Movement to Highlight the Value of Freedom as a Blessing. 22 August 2026",
        },
      {
          title: "Dr Fowzia pledges to continue Aafia release mission untiringly",
          link: "https://cdn.cloudious.net/file-1784032486045-629471315.pdf",
          image: "https://cdn.cloudious.net/file-1784032445078-487698619.jpg",
          about: "Dr Fowzia pledges to continue Aafia release mission untiringly. 13 July 2026",
        },
      {
          title: "Dr Fowzia urges intellectuals to play role for Aafia release",
          link: "https://cdn.cloudious.net/file-1782295226024-479724058.pdf",
          image: "https://cdn.cloudious.net/file-1782296371426-90002662.jpg",
          about: "Dr Fowzia urges intellectuals to play role for Aafia release. 22 June 2026",
        },
      {
          title: "Poetry reciting session held to pay tribute to Dr. Aafia and her family",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1779785614294-6298293.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Poetry reciting session held to pay tribute to Dr. Aafia and her family. 24 May 2026",
        },
      {
          title: "Dr Aafia is only a Pakistani citizen: Spokesman Aafia Movement",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1765176696684-772350885.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Dr Aafia is only a Pakistani citizen: Spokesman Aafia Movement. 05 Dec 2025",
        }, {
          title: "Aafia Siddiqui case: IHC asks AAG to file amicus brief by Jan 20th",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1765176696154-347513822.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Aafia Siddiqui case: IHC asks AAG to file amicus brief by Jan 20th. 03 Dec 2025",
        },
      {
          title: "Flotilla interception by Israel: Where is the United Nations? Asks Fowzia Siddiqui",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1760116704315-998574530.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Flotilla interception by Israel: Where is the United Nations? Asks Fowzia Siddiqui. 03 Oct 2025",
        },
        {
          title: "Aafia could be freed in a couple of days if",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1760515781583-947176508.pdf",
          image: "https://cdn.cloudious.net/file-1760515958343-291054737.jpg",
          about: "Aafia could be freed in a couple of days if our government shows political will, 17 Sept 2025",
        },
        {
          title: "Dr. Fowzia Siddiqui urges the public to remain patient",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1758098629881-807273406.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Dr. Fowzia Siddiqui urges the public to remain. 30 July 2025",
        },
        {
          title: "Why Is the Pakistani Government Unwilling",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1759480329051-517016055.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Why Is the Pakistani Government Unwilling to Either Help Aafia Siddiqui or Honestly Admit 11 July 2025",
        },
        {
          title: "US Independence Day: Dr Fowzia reiterates demand for Aafia release",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1758098630095-166290244.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Dr. Fowzia Siddiqui urges the public to remain. 03 July 2025",
        },
        {
          title: "Aafia’s American Lawyer coming on May 6",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1759480329507-48705204.pdf",
          image: "https://cdn.cloudious.net/file-1757937262510-465097473.jpg",
          about: "Aafia’s American Lawyer coming on May 6: Lawyer says, Government telling 'dirty lies' to Court on Aafia’s Case 14 April 2025",
        },
        {
          title: "Peaceful demo held in front of prison where Aafia Siddiqui is jailed",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1758098630111-810321713.pdf",
          image: "https://cdn.cloudious.net/file-1757936293404-966131629.jpg",
          about: "Peaceful demo held in front of prison where Aafia. 23 Oct 2024",
        },
        {
          title: "Condemning 86-year jail term of Dr Aafia Aafia Movement",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1758098629824-939843590.pdf",
          image: "https://cdn.cloudious.net/file-1757936668222-211335708.jpg",
          about: "Condemning 86-year jail term of Dr Aafia Movement holds peaceful demos in different. 22 Oct 2024",
        },
        {
          title: "Lawyer says Dr Aafia desperately needs medical help",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1758098630091-33710991.pdf",
          image: "https://cdn.cloudious.net/file-1757936668222-211335708.jpg",
          about: "Lawyer says Dr Aafia desperately needs medical help. 21 Oct 2024",
        },
        {
          title: "Dr Fowzia warmly welcome Govt's letter seeking",
          // link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
          link: "https://cdn.cloudious.net/file-1758098630101-949688651.pdf",
          image: "https://cdn.cloudious.net/file-1757936668222-211335708.jpg",
          about: "Dr Fowzia warmly welcome Govt's letter seeking US presidential pardon for Dr Aafia. 18 Oct 2024",
        },
        //   {
        //   title: "Mushahid Hussan Senate Report",
        //   // link: "https://cdn.cloudious.net/file-1680592746791-736704285.pdf",
        //  link: "https://cdn.cloudious.net/file-1758098630117-83117822.pdf",
        //   image: "images/Untitled design(1).png",
        //   about:
        //     "Report of the Standing Committee on Foreign Affairs with Dr. Afia Siddiqui on 7th October 2008 at Texas, USA.",
        // },
   
//         {
//           title: "Aafia - Cage",
// //link: "https://cdn.cloudious.net/file-1680590739404-523697500.pdf",
// link: "https://cdn.cloudious.net/file-1757941104246-480349257.pdf",

//           image: "images/Untitled design(2).png",
//           about: "Dr. Afia Siddiqui, a case of lies and inconsistencies",
//         },
        {
          title: "Aafia-Movement Mission Statement",
          // link: "https://cdn.cloudious.net/file-1680592416782-51880220.pdf",
          link: "https://cdn.cloudious.net/file-1758098629161-97824760.pdf",
          image: "images/aafia-mission.jpg",
          about:
            "The Aafia Movement is an umbrella organization which includes everybody and every organization.",
        },
        // {
        //   title: "Rally in London demands release of Aafia on compassionate grounds",
        //    link: "https://cdn.cloudious.net/file-1680592494661-53614084.pdf",
        //   link: "https://cdn.cloudious.net/file-1757935905237-179645027.pdf",
        //   image: "https://cdn.cloudious.net/file-1757936026958-282803355.jpg",
        //   about: "Rally in London demands release of Aafia on. 23 Oct 2024",
        // },
        // {
        //   title: "True Facesheet",
        //   link: "https://cdn.cloudious.net/file-1680592556841-934946671.pdf",
        //   image: "images/facts-1.png",
        //   about: "These are the True facts about Dr. Aafia Siddiqui.",
        // },
        // {
        //   title: "Who is Aafia?",
        //   link: "https://cdn.cloudious.net/file-1689692013598-226105485.pdf",
        //   image: "images/afia-siddiqui(1).jpg",
        //   about: "Let’s decode the truth about Dr. Aafia Siddiqui’s Case.",
        // },
        {
          title: "Press Release",
          link: "https://cdn.cloudious.net/file-1756124014113-217653739.pdf",
          image: "https://cdn.cloudious.net/file-1692184469118-262790337.jpg",
          about: "IHC Adjourns Aafia Siddiqui’s Case till Nov 17",
        },
        {
          title: "Remembering the Children of Gaza",
          link: "https://cdn.cloudious.net/file-1756124014832-790060831.pdf",
          image: "https://cdn.cloudious.net/file-1701340205777-827965176.jpg",
          about:
            "On the Occasion of World Children's Day, Remembering the Children of Gaza is Essential, Urges Dr. Fowzia Siddiqui",
        },
        // {
        //   title: "Dr. Fowzia meets Dr. Aafia",
        //   link: "https://cdn.cloudious.net/file-1701875120467-663905374.pdf",
        //   image: "https://cdn.cloudious.net/file-1701874907567-644056277.jpg",
        //   about:
        //     "Fowzia meets Aafia in prison, expresses concern on her deteriorating health",
        // },
        {
          title: "Islamabad High Court hearing",
          link: "https://cdn.cloudious.net/file-1755518372897-595971521.pdf", //"https://cdn.cloudious.net/file-1705915810008-926072308.jpg",
          image: "https://cdn.cloudious.net/file-1705915868272-301620461.jpg",
          about: "IHC asks some serious questions",
        },
        {
          title: "Dr. Aafia Siddiqui Conference, Islamabad",
          link: "https://cdn.cloudious.net/file-1755518372623-685265021.pdf", //"https://cdn.cloudious.net/file-1706081570158-868170192.jpg",
          image: "https://cdn.cloudious.net/file-1706081705738-727612031.jpg",
          about:
            "Govt not using available legal, political options for Aafia release: Dr Fowzia",
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      const searchQuery = this.$store.state.searchQuery?.toLowerCase().trim() || "";
      if (!searchQuery) {
        return this.docs;
      }
      return this.docs.filter(
        (item) =>
          item.title?.toLowerCase().includes(searchQuery) ||
          item.about?.toLowerCase().includes(searchQuery)
      );
    },
  },
  methods: {
    highlightText(text, query) {
      if (!text || !query || !query.trim()) {
        return text || '';
      }
      
      const searchQuery = query.trim();
      const escapedQuery = this.escapeRegex(searchQuery);
      const regex = new RegExp(`(${escapedQuery})`, 'gi');
      
      // Escape HTML first, then highlight
      const escapedText = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return escapedText.replace(regex, '<mark class="search-highlight">$1</mark>');
    },
    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
  },
};
</script>
<style scoped>
.team-member-image-2.image-align-top {
  object-position: top;
}

.no-results {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 18px;
}

/* Search results header */
.search-results-header {
  margin-bottom: 30px;
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-left: 4px solid #198754;
  border-radius: 4px;
}

.search-results-info {
  margin: 0;
  color: #333;
  font-size: 16px;
}

.search-results-info strong {
  color: #198754;
  font-weight: 700;
}

.search-query-badge {
  background-color: #198754;
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
  margin-left: 8px;
}

/* Search highlight styling */
:deep(.search-highlight) {
  background-color: #198754;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(25, 135, 84, 0.3);
  display: inline-block;
}
</style>
